import { useContext } from "react";
import leftyTears from "../../assets/img/leftytears.png";
import animatedLogo from "../../assets/img/logo.gif";
import "./MainSection.css";
import { TitleBox } from "../Liquidity/Details/styled";
import logoLarge from "../../assets/img/logo-large.png";
import {
  ContextProviderWrapper,
  convertFixed,
} from "@kibble-exchange/uikit";
import CountdownTimer from "./CountdownTimer";
import {
  FairBox,
  FairProgress,
  FairProgressBar,
  FairProgressCompare,
  FairProgressHeader,
  FairProgressPercent,
} from "../Launchpad/FAIR/styled";
import { useSelector } from "react-redux";
import { getGlobalDataPresale, getUserDataPresale } from "store/features/presaleSlice";

const MainSection = () => {
  const { isMobile, theme }: any = useContext(ContextProviderWrapper);
  const { globalData, userdata } = useSelector((state: any) => state.presale);
  const calcProgress = () => {
    return (Number(globalData.cap) - Number(globalData.total_supply)) / Number(globalData.cap);
  };

  return (
    <section className="main-section" style={{ marginTop: "0px", marginBottom: "40px" }}>
      <img src={logoLarge} alt="Logo Large" className="logo-overlay" />
      <TitleBox>
        <h1 className="text-center h1">Presale</h1>
      </TitleBox>
      {/*<TitleBox style={{ marginTop: "0px", marginBottom: "20px" }}>
        <h1 className="text-center h1">
          Welcome to
          <br />
          <div className="flex flex-row project-name">
            <img src={logoLarge} width="32px" height="32px" alt="" />
            <span className="hodl-color">Hodl Holdings</span>
          </div>
        </h1>
      </TitleBox>*/}
      {/*<div className="timer-text-box">
        {globalData?.end_date && <CountdownTimer targetDate={Number(globalData.end_date)} />}
        <div style={{ maxWidth: "520px", marginRight: "auto", marginLeft: "auto" }}>
          <FairBox>
            <FairProgress>
              <FairProgressHeader>
                <p>Progress</p>
                <p>
                  <span>{calcProgress() * 100}%</span>
                </p>
              </FairProgressHeader>
              <FairProgressBar Progress={calcProgress() * 100}>
                <span></span>
              </FairProgressBar>
              <FairProgressPercent>
                <span>{globalData && globalData.cap - globalData.total_supply}</span>
                <span> /{globalData && convertFixed(globalData?.cap ?? 0)}</span>
              </FairProgressPercent>
              <FairProgressCompare>
                <p>
                  <span>1</span> LEFTYTEARS = <span>{(1 / globalData.price).toFixed(4)} TON</span>
                </p>
              </FairProgressCompare>
            </FairProgress>
          </FairBox>
        </div>
      </div>*/}
      <p className="main-description">
        Secure your position early by investing in our presale and don't miss out on this unique
        opportunity!
      </p>
      <p className="main-description">
        Our token <span className="token-name">$LeftyTears</span> is designed with advanced features
        and attractive tokenomics, including a limited supply and a deflationary mechanism through
        token burns. Enjoy the benefits of earning high yields through staking, investing into farms
        or providing liquidity. Participate in our innovative game to win exciting rewards and
        engage with a thriving community.
      </p>
      <p className="main-description">
        <span className="token-name">$LeftyTears</span> token is made to incentivize long-term value
        growth, making it an excellent investment choice. Join us today and be part of the future of
        Hodl Holdings.
      </p>
    </section>
  );
};

export default MainSection;
